import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Shield, Zap, Award } from 'lucide-react';
import { companyInfo, aboutContent } from '../mock';

const About = () => {
  const valueIcons = {
    'Reliability': Shield,
    'Expertise': Award,
    'Speed': Zap,
    'Quality': Target
  };

  return (
    <div className="page-container">
      {/* About Hero */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="page-title">About Connect EDGE IT Services</h1>
          <p className="page-subtitle">
            Your trusted partner for on-site IT support and infrastructure solutions in Chicago
          </p>
        </div>
      </section>

      {/* Team Section with Image */}
      <section className="team-section">
        <div className="team-content">
          <div className="team-image-container">
            <img 
              src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800" 
              alt="Connect EDGE IT Services Team" 
              className="team-image"
            />
          </div>
          <div className="team-text">
            <h2 className="section-title">Our Team</h2>
            <p className="team-description">
              Connect EDGE IT Services is powered by a dedicated team of certified IT professionals with extensive experience in enterprise infrastructure, data centers, and network operations. Based in Chicago, our engineers are ready to provide expert on-site support 24/7.
            </p>
            <p className="team-description">
              We specialize in working with leading technologies including Cisco, Meraki, and other enterprise-grade equipment, ensuring your critical infrastructure stays operational and optimized.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="mission-content">
          <h2 className="section-title">Our Mission</h2>
          <p className="mission-text">{aboutContent.mission}</p>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="section-header">
          <h2 className="section-title">Our Core Values</h2>
        </div>
        <div className="values-grid">
          {aboutContent.values.map((value, index) => {
            const IconComponent = valueIcons[value.title];
            return (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="section-header">
          <h2 className="section-title">Why Choose Us</h2>
          <p className="section-description">
            What sets Connect EDGE apart from other IT service providers
          </p>
        </div>
        <div className="why-choose-list">
          {aboutContent.whyChooseUs.map((reason, index) => (
            <div key={index} className="why-choose-item">
              <div className="check-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p className="why-choose-text">{reason}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Service Area with Image */}
      <section className="service-area-section">
        <div className="service-area-content">
          <h2 className="section-title">Service Area</h2>
          <div className="service-area-grid">
            <div className="service-area-text-content">
              <p className="service-area-text">
                Based in <strong>Chicago, IL 60630</strong>, we provide rapid on-site response throughout 
                the Chicago metropolitan area. Our strategic location enables us to quickly reach your 
                site for installations, troubleshooting, and emergency incidents.
              </p>
              <div className="service-area-highlight">
                <h3 className="highlight-title">Available 24/7</h3>
                <p className="highlight-text">
                  We understand that infrastructure issues don't follow a schedule. That's why we're 
                  available 7 days a week, including holidays, with emergency response capabilities 
                  for critical P1/P0 incidents.
                </p>
              </div>
            </div>
            <div className="service-area-image-container">
              <img 
                src="https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?w=800" 
                alt="IT Professional in Data Center" 
                className="service-area-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Work Together?</h2>
          <p className="cta-description">
            Let's discuss how we can support your IT infrastructure needs
          </p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary">
              Contact Us
              <ArrowRight size={20} />
            </Link>
            <Link to="/services" className="btn-secondary">
              View Our Services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
